export default __webpack_public_path__ + "static/media/secondary.339132460517eaaee9d8e5184e4f1c02.svg";